export default __webpack_public_path__ + "static/media/target.ab9c0d10.svg";